import { BaseItem, NullablePartial } from '../common';

export enum Kind {
  AthenaIDX = 'ATHENAIDX',
  AthenaOne = 'ATHENAONE',
  FHIRCerner = 'FHIR_CERNER',
  FHIREClinicalWorks = 'FHIR_ECLINICALWORKS',
  EPIC = 'FHIR_EPIC',
  EpicAppMarket = 'EPIC_APP_MARKET',
}

export interface BaseApiInstance {
  authenticationUrl: string;
  baseUrl: string;
  bearerTokenGcsmReferenceId: string | null;
  deploymentName: string;
  clientId: string;
  clientSecretGcsmReferenceId: string | null;
  kind: Kind;
  mrnURI: string | null;
  encounterUrn: string | null;
  privateKeyGcsmReferenceId: string | null;
  name: string;
  basicAuthGcsmReferenceId: string | null;
  organizationReferenceId: string | null;
  patientIdType: string | null;
  previousBalancePatientIdType: string | null;
}

export interface ApiInstance extends BaseApiInstance, BaseItem {}

export interface FindAllOptions extends Partial<Pick<ApiInstance, 'kind'>> {}
export type CreateValues = NullablePartial<
  Omit<
    BaseApiInstance,
    | 'bearerTokenGcsmReferenceId'
    | 'clientSecretGcsmReferenceId'
    | 'privateKeyGcsmReferenceId'
    | 'basicAuthGcsmReferenceId'
  >
> & {
  bearerToken?: string;
  privateKey?: string;
  clientSecret?: string;
  basicAuth?: string;
};
export type UpdateValues = Partial<BaseApiInstance>;

export interface FindAllOptions {
  authenticationUrl?: string;
  baseUrl?: string;
  deploymentName?: string;
  clientId?: string;
  kind?: Kind;
}
